<template>
  <!-- Main Framework7 App component where we pass Framework7 params -->
  <f7-app :params="f7params">
    <!-- Main View -->
    <f7-view id="main-view" url="/" main :push-state="true"></f7-view>
  </f7-app>
</template>

<style src="./css/app.css"></style>

<script>
import routes from './routes.js'

export default {
  name: 'app',
  components: {
  },
  data() {
    return {
      f7params: {
        routes,
        name: '楊枝金撈後台下單系統',
        id: 'com.goldenmixdessert.supply-order',
      }
    }
  },
}
</script>
